<script setup>
import Card from '@/Components/Card/Card.vue';
</script>
<template>
  <Card class="bg-section mt-2 text-sm">
    <div class="flex flex-col gap-4 md:gap-3">
      <slot />
    </div>
  </Card>
</template>
